import { render, staticRenderFns } from "./AdminEduLangAdd.vue?vue&type=template&id=e3875d1c"
import script from "./AdminEduLangAdd.vue?vue&type=script&lang=js"
export * from "./AdminEduLangAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports